import React, { Component } from 'react';
import EditorButtons from './EditorButtons';
import { MODELS, RT_TYPE_CONTRACT } from '../../../../constants/admin/settings';
import { UserContext } from '../../../../Application';
import { ifPermission, PERMISSIONS } from '../../../../constants/authentication/permissions';
import SelectField from '../../../forms/SelectField';
import RTEWithComments from '../../hocs/RTEWithComments';
import Activity from './Activity';
import { transformContractText } from '../../../../selectors/admin/models/contracts';
import UploadButton from '../UploadButton';
import TinyMCERichTextEditor from '../TinyMCERichTextEditor';

class ContractEditor extends Component {
    state = { fetching: false, richText: '', setCounter: 0 };
    componentDidMount() {
        this._fetchVersions();
    }
    componentDidUpdate = prevProps => {
        if (this.props.editing && prevProps.readOnly === false && this.props.readOnly === true) {
            this._doneEditor();
        }
        if (this.props.templateId && this.props.templateId !== prevProps.templateId) {
            const transformed = transformContractText(this.props.templateData, this.props);
            this.setState({ richText: transformed });
        }
        if (
            (this.props.artistName && this.props.artistName !== prevProps.artistName) ||
            (this.props.eventName && this.props.eventName !== prevProps.eventName) ||
            this.props.formData.performances.join('') !== prevProps.formData.performances.join('')
        ) {
            this._transformContent(this.state.firstTimeSet);
        }
        this._fetchVersions();
    };
    _transformContent = () => {
        const isEditing = this.props.editing;
        const transformed = transformContractText(
            isEditing ? this.state.richText || '' : this.props.formData.data || '',
            this.props
        );
        if (this.props.editing) {
            this.setState({ richText: transformed });
        } else {
            this.props.onInput(MODELS.CONTRACT, 'data', transformed, this.state.setCounter < 3);
            this.setState({ setCounter: this.state.setCounter + 1 });
        }
    };
    _fetchVersions = () => {
        if (this.props.contractId && !this.props.allVersions.length && !this.state.fetching) {
            this.setState({ fetching: true });
            this.props.fetchVersions(this.props.contractId);
        } else if (this.props.allVersions.length && this.state.fetching) {
            this.setState({ fetching: false });
        }
    };
    _startEditor = () => {
        this.setState({ richText: this.props.formData.data || '' });
        this.setState({ setCounter: 4 });
        this.props.onInput(MODELS.CONTRACT, 'editing', true);
    };
    _cancelEditor = () => this.props.onInput(MODELS.CONTRACT, 'editing', false);
    _editEditor = richText => this.setState({ richText });
    _doneEditor = () => {
        this.props.onInput(MODELS.CONTRACT, 'data', this.state.richText);
        this.props.onInput(MODELS.CONTRACT, 'editing', false);
    };
    _downloadVersion = () => {
        this.props.downloadVersion(this.props.contractId, this.props.version.id);
    };
    render() {
        return (
            <div className="ckp-contracts-editor">
                <header className="ckp-contracts-editor-header">
                    <h1 className="ckp-contracts-editor-title ">
                        {this.props.contractId ? (
                            <SelectField
                                label={'Contract Version'}
                                disabled={this.props.editing}
                                onChange={this.props.switchVersion}
                                className="ckp-contracts-editor-version-select"
                                value={this.props.selectedVersion}
                                items={this.props.allVersions}
                            />
                        ) : (
                            <span className="ckp-ts-h1">Contract</span>
                        )}
                    </h1>
                    {
                        <div className="u-flex">
                            {this.props.version && this.props.version.isUpload ? (
                                <UploadButton onClick={this._downloadVersion} fileName="DOWNLOAD PDF" readOnly />
                            ) : null}
                            <UserContext.Consumer>
                                {user =>
                                    ifPermission(
                                        user,
                                        PERMISSIONS.CONTRACT_EDIT,
                                        <EditorButtons
                                            readOnly={this.props.readOnly}
                                            fileData={this.props.fileData}
                                            removeFile={this.props.removeFile}
                                            editing={this.props.editing}
                                            onCancel={this._cancelEditor}
                                            onStart={this._startEditor}
                                            onDone={this._doneEditor}
                                        />
                                    )
                                }
                            </UserContext.Consumer>
                        </div>
                    }
                </header>
                <main className="ckp-contracts-editor-main ckp-admin-grid-row">
                    <RTEWithComments
                        user={this.props.versionUser}
                        version={this.props.selectedVersion}
                        data={this.props.data}
                        comments={this.props.feedback}
                        editing={this.props.editing}
                    >
                        {this.props.editing ? (
                            <TinyMCERichTextEditor
                                type={RT_TYPE_CONTRACT}
                                onChange={this._editEditor}
                                value={this.props.editing ? this.state.richText : this.props.formData.data || ''}
                                disabled={!this.props.editing}
                                onInsertContent={this._transformContent}
                            />
                        ) : (
                            <div
                                className="ckp-contracts-editor-read ckp-rich-text-content is-editor"
                                dangerouslySetInnerHTML={{ __html: this.props.formData.data || '' }}
                            ></div>
                        )}
                    </RTEWithComments>
                    <Activity
                        contractId={this.props.contractId}
                        activity={this.props.activity}
                        data={this.props.formData}
                    />
                </main>
            </div>
        );
    }
}

export default ContractEditor;



// WEBPACK FOOTER //
// ./src/components/admin/forms/contracts/ContractEditor.js